// extracted by mini-css-extract-plugin
export var container = "_8c-1";
export var cornerButtonContainer = "_8c-5";
export var disabled = "_8c-2";
export var fileContainer = "_8c-4";
export var hiddenInput = "_8c-3";
export var widthContainer = "_8c-0";